import { useGetMyPaymentSourcesQuery } from '@src/apollo/hooks';

export function useDefaultPaymentMethod() {
  const { data } = useGetMyPaymentSourcesQuery();
  return (
    data?.getMyPaymentSources?.find((card) => card?.isDefault) ??
    data?.getMyPaymentSources?.[0]
  );
}
